/**
  This code is classfree object oriented. No this. No prototype. No class.
  Inspired by Douglas Crockford (see https://youtu.be/XFTOG895C7c?t=2562)
*/
import JQx from "./src/JQxConstructorFactory.js";
export default JQx;
